import React from 'react';

export const SkillGapNeedsAttention: React.FC = () => {
  return (
    <div className="modal-template skill-gap-attention">
      <h3>Skill Gap Identified</h3>
      <p>A student has a skill gap in phoneme segmentation that requires attention.</p>
      <div className="skill-visualization-placeholder">
        <div className="chart-placeholder">
          [Skill Proficiency Chart]
        </div>
      </div>
      <p>Addressing this skill gap now will help prevent future reading challenges.</p>
      <div className="action-buttons">
        <button className="btn btn-primary">View Recommended Activities</button>
        <button className="btn btn-secondary">Schedule Intervention</button>
      </div>
    </div>
  );
};

export default SkillGapNeedsAttention; 